module.exports = __webpack_public_path__ + "static/Campus_Security_Act_Disclosure_2024.1-9df8ebce223d9674dcd04299350cf037.pdf";